import React, { useEffect, useRef, useState } from "react";
import { isEmptyOrNull } from "../../../utils/common-utils";
import "./input.css?__remix_sideEffect__";
import { useBreakpointValue } from "@chakra-ui/react";

export default function EditableDiv({
  content,
  setContent,
  isDisable,
  index,
  isExperiential = false,
  isStandalone = false
}) {
  const editorRef = useRef();
  const textRef = useRef(null);
  const [editorLoaded, setEditorLoaded] = useState(false);
  const { ContentEditable } = editorRef.current || {};
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
    lg: false
  });

  useEffect(() => {
    if (textRef?.current) {
      textRef?.current?.focus();
    }
    editorRef.current = {
      ContentEditable: require("react-contenteditable").default
    };
    setEditorLoaded(true);
  }, [isDisable]);

  const sanitizeInput = (input) => {
    return input.replace(/\n/g, "<br/>");
  };

  const handleKeyDown = (e) => {
    if (isMobile) {
      if (e.key === "Enter") {
        e.preventDefault();
        document.execCommand("insertHTML", false, "<br><br>");
      }
    } else {
      if (e.key === "Enter" && e.shiftKey) {
        e.preventDefault();
        document.execCommand("insertHTML", false, "<br><br>");
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    if (isExperiential || isStandalone) {
      const text = (e.clipboardData || window.clipboardData).getData(
        "text/plain"
      );
      document.execCommand("insertText", false, text);
    }
  };

  const handleChange = (e) => {
    setContent(e.target.value);
  };

  return (
    <>
      {editorLoaded &&
      <ContentEditable
        innerRef={textRef}
        tagName="div"
        className={`editable-div ${!isEmptyOrNull(content) ? "placeholder" : ""}`
        }
        disabled={isDisable ? true : false}
        html={sanitizeInput(content)}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        data-placeholder={
        isDisable || index !== 0 ?
        "" :
        isExperiential ?
        "Briefly describe your activity here. Refer the reference material for instructions" :
        "Please respond to Vin"
        } />

      }
    </>);

}